export default function Trigger() {
    let fired = false,
        cancelled = false,
        cancellationReason,
        callbacks = [];

    // execute all callbacks, empty callback queue
    const runCallbacks = () => {
        let wrappedCallbackFn;
        while (wrappedCallbackFn = callbacks.shift())
            wrappedCallbackFn();
    };
            
    // set fired flag,
    // execute all callbacks, empty callback queue
    const fire = () => {
        fired = true;

        runCallbacks();

        // to allow:
        // const {onFire} = new Trigger().fire();
        return result;
    };

    // set cancel flag, remember cancellation reason,
    // execute all callbacks, empty callback queue
    const cancel = reason => {
        cancelled = true;
        cancellationReason = reason;

        runCallbacks();

        // to allow:
        // const {onFire} = new Trigger().cancel();
        return result;
    };

    // onFire:
    // - takes callbackFn,
    // - wraps it with try catch, 
    // - executes immediately or registers for later execution 
    // - and returns promise resolved or rejected depending on callback execution result
    const onFire = callbackFn => new Promise( (resolveFn, rejectFn) => {
        const wrappedCallbackFn = () => {
            if (cancelled)
                return rejectFn( cancellationReason );

            try {
                resolveFn( callbackFn() );
            } catch(ex) {
                rejectFn( ex );
            }
        };

        if (fired || cancelled)
            wrappedCallbackFn();
        else 
            callbacks.push( wrappedCallbackFn );

        return result;
    } );

    let result; return result = {
        fire,
        onFire,
        cancel,
    };
}


// WEBPACK FOOTER //
// ./src/js/utils/trigger.js